import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  { path: 'transacciones',
    loadChildren: () => import('./transactions/transactions.module').then(m => m.TransactionsModule) },
  { path: 'lista-negra', loadChildren: () => import('./blacklist/blacklist.module').then(m => m.BlacklistModule) },
  { path: 'liberar-lista-negra',
    loadChildren: () => import('./unblock-blacklist/unblock-blacklist.module').then(m => m.UnblockBlacklistModule) },
  { path: 'devoluciones', loadChildren: () => import('./refund/refund.module').then(m => m.RefundModule) },
  { path: 'contracargos', loadChildren: () => import('./chargebacks/chargebacks.module').then(m => m.ChargebacksModule) },
  { path: '**', redirectTo: 'transacciones'},
  ];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MainRoutingModule { }
